<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <c-card title="Editar municipio">
          <city-form />
        </c-card>
      </div>
    </div>
  </div>
</template>
<script>
import CityForm from "@/components/Forms/CityForm.vue";
import CCard from "@/components/CCard.vue";
export default {
  components: {
    CityForm,
    CCard,
  },
};
</script>
